import { CurrencyOptions } from '../../../i18n';
import { ConfigState, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';
import { ConfigGetter } from '../config.interfaces';

export class CurrencyGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.currency]: (configState: ConfigState, getters: any): CurrencyOptions => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      const { currency, lang } = configState.dynamic;
      return config.locale.currencies[`${ currency }-${ lang }`] ?? config.locale.currencies[currency];
    }
  };
}
